import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async';
import ListGroup from './partials/ListGroup';
import UserHero from './partials/UserHero';
import UserAccount from './partials/UserAccount';
import HomeProfile from './partials/HomeProfile';


export default function UserHomePage() {
  //  
  return (
    <>
      {/* SEO */}
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <UserHero />
      <div className="container">
        <UserAccount />
        {
          localStorage.getItem("login") ? (localStorage.getItem("role") === "@A*_s&_k!=!@h!-%" ?
            <div className="row">
              {/* <Sidebar/> */}
              <ListGroup />
              <HomeProfile />
            </div>
            :

            <div className="row">
              <ListGroup />
              <HomeProfile />

            </div>
          ) :
            ""
        }
      </div>





    </>
  )
}
